module.exports = __webpack_public_path__ + "static/img/icon.ae9108a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/icon.jpg
// module id = q2Ou
// module chunks = 0